import firebase from 'firebase/app'
import 'firebase/storage'
import { reactive } from '@vue/composition-api'
import set from '../set/'
import update from '../update/'
import resizeImage from '@iez/lib/resize-image/'

export default ({ file, type, nativeCallback }) => {
  const root = `${type}s`
  const storage = firebase.storage()

  const state = reactive({
    progress: 0,
    id: ``
  })

  const start = async () => {
    /**
     * Create File in Hasura
     */
    const { id } = await set({
      root,
      items: [{
        ...type === `image`
          ? (file.placeholder
            ? {
              src: file.placeholder,
              srcLazy: file.placeholder
            } : {
              srcLazy: await resizeImage({
                data: file,
                wantedWidth: 32,
                wantedHeight: 32,
                blur: 2
              })
            }
          ) : null
      }],
      one: true,
      fields: [`id`]
    })
    state.id = id

    if (file.placeholder) {
      state.progress = 100
      return
    }

    if (!nativeCallback) {
      /**
       * Create ref with Hasura object id in Firebase Storage
       */
      const storageRef = storage.ref()
      const fileRef = storageRef.child(id)


      const getFileBlob = ({ url }) => new Promise(resolve => {
        const xhr = new XMLHttpRequest()
        xhr.open(`GET`, url)
        xhr.responseType = `blob`
        xhr.addEventListener(`load`, () => {
          resolve(xhr.response)
        })
        xhr.send()
      })
      /**
        * Upload file to Firebase Storage and get URL
        */
      const putter = typeof file === 'string' && !file.startsWith(`blob:`)
        ? fileRef.putString(file, `data_url`)
        : fileRef.put(
          file.startsWith(`blob:`)
            ? await getFileBlob({ url: file })
            : file
        )
      putter.on(
        'state_changed',
        ({ bytesTransferred, totalBytes }) => {
          const progress = (bytesTransferred / totalBytes) * 100
          state.progress = progress === 100 ? 99 : progress
        },
        error => {
          console.error(error.message)
        },
        async () => {
          const src = await fileRef.getDownloadURL()
          /**
            * Update Hasura Object with src
            */
          await update({
            root,
            id,
            fields: [
              `id`,
              `src`,
              type === `image`
                ? `srcLazy`
                : undefined
            ].filter(Boolean),
            _set: {
              src
            }
          })
          state.progress = 100
        }
      )
    } else {
      const { downloadUrl } = await nativeCallback({
        id,
        path: file
      })
      await update({
        root,
        id,
        fields: [
          `id`,
          `src`,
          type === `image`
            ? `srcLazy`
            : undefined
        ].filter(Boolean),
        _set: {
          src: downloadUrl
        }
      })
      state.progress = 100
    }
  }

  start()

  return state
}
